<agm-map
  id="agm-map"
  [latitude]="latitude"
  [longitude]="longitude"
  [zoom]="zoom"
  [minZoom]="limitZoom"
  [zoomControl]="true"
  [fullscreenControl]="true"
  [streetViewControl]="false"
  *ngIf="!streetView"
>
  <agm-circle
    *ngIf="radius"
    [latitude]="latitude"
    [longitude]="longitude"
    [radius]="radius"
    [fillColor]="colorRadius"
  >
  </agm-circle>

  <agm-marker
    *ngIf="!radius"
    [latitude]="latitude"
    [longitude]="longitude"
  ></agm-marker>
</agm-map>
<div [attr.id]="'street-view-' + idMap" *ngIf="streetView"></div>

